import { inject, Injectable } from "@angular/core";
import { SubscriptionApi } from "../../api/proxies";

@Injectable()
export class SubscriptionDetailsService {
    tagMap: Map<number, string> = new Map<number, string>();

    private _subscriptionApi = inject(SubscriptionApi);

    getSubscriptionDetails() {
        return this._subscriptionApi.details();
    }
}
